import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResourceBaseService } from '../../resource-base.service';
import { BsApiEndPoints } from '../endpoints';
import { Observable, of } from 'rxjs';
import { map, catchError, share } from 'rxjs/operators';
import { IKeepAlive } from '../../../model/keep-alive/keep-alive'
import { IApiResponseWrapper } from '../../../model/v2-api/v2-api-wrappers';

@Injectable({
  providedIn: 'root'
})
export class BsKeepAliveService extends ResourceBaseService<IApiResponseWrapper<IKeepAlive>> {

  constructor(httpClient: HttpClient) {
    super(httpClient, BsApiEndPoints.v2KeepAlive);

  }

  /**
   * Checks if the current session(defined by pstoken cookie) is alive and updates the session if it is not idle.
   */
  keepSessionAlive(): Observable<IKeepAlive> {
    return this.post(null, null).pipe(share(),
      map((apiResponse) => {
        return {
          TokenValid: apiResponse.Response.TokenValid,
          IdleTimeoutInSeconds: apiResponse.Response.IdleTimeoutInSeconds
        };
      }),
      catchError((error) => {
          return of({
            TokenValid: false,
            IdleTimeoutInSeconds: 0
          });
      })
    );

  }

  /**
   * Check is if the current session is alive
   */
  validateSession(): Observable<boolean> {
    return this.keepSessionAlive().pipe(map(
      (keepAliveValue) => {
        return keepAliveValue.TokenValid;
      }
    ));
  }

}
